import React, { useState } from 'react';
import { Typography, InputBase } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import useStyles from './style';

export default function Title({ originTitle, handleUpdateTitle, titleListId }) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [title, setTitle] = useState(originTitle);

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleOnBlur = () => {
    setOpen(!open);
    handleUpdateTitle(title, titleListId);
  };
  return (
    <div>
      {open ? (
        <div className={classes.editableTitleContainer}>
          <Typography
            className={classes.editableTitle}
            onClick={() => setOpen(!open)}
            variant="body2"
          >
            {title}
          </Typography>
          <MoreHorizIcon />
        </div>
      ) : (
        <div className={classes.plainTitle}>
          <InputBase
            fullWidth
            autoFocus
            onChange={handleTitleChange}
            onBlur={handleOnBlur}
            value={title}
            inputProps={{
              className: classes.input,
            }}
          />
          <MoreHorizIcon />
        </div>
      )}
    </div>
  );
}
